/*
*props:
* 材料
* material : {
* text: str or Array
  pic: string
  audio: str
* }
* 题干
* stem: {
* text: str or Array
  pic: string
  audio: str
* }
* category: wring/speaking...//not default
* 是否可以查看译文
* additionMaterial:{text: array}//报告页进入的需要传入
* additionCallback: function 查看译文后的函数
*
* */
import React, { Component } from 'react';
import config from 'config';
import Audio from 'components/Common/Audio';
import style from './index.css';

export default class Material extends Component{
  constructor() {
    super();
    this.state = {
      showAddition: false
    }
  }
  componentWillReceiveProps(nextProps) {

  }
  stemToHTML(array) {
    return (
      <ul className={style.ulList}>
        { array.map((item,index)=> {
          return (
            <li key={index} dangerouslySetInnerHTML={{ __html: item.raw }} ></li>
          )
        }) }
      </ul>
    )
  }
  additionToHTML(array) {
    return (
      <div className={style.ulList}>
        { array.map((item,index)=> {
          return (
            <div key={index}>
              <div  dangerouslySetInnerHTML={{ __html: item.raw }} ></div>
              <div  dangerouslySetInnerHTML={{ __html: item.trans }}></div>
            </div>
          )
        })}
      </div>
    )
  }
  showAddition = ()=> {
    if(typeof this.props.additionCallback === 'function') {
      this.props.additionCallback()
    }
    this.setState({
      showAddition : !this.state.showAddition
    })
  }
  render() {
    let { category , isSingleLayout } = this.props;
    let textMaterial = this.props.material ? this.props.material.text : '';
    let additionText = this.props.additionMaterial ? (this.props.additionMaterial.text || '' ): '';
    let pictureMaterial = this.props.material ? this.props.material.picture : '';
    let audioMaterial = this.props.material ? this.props.material.audio : '';
    let textStem = this.props.stem ? this.props.stem.text : '';
    let pictureStem = this.props.stem ? this.props.stem.picture : '';
    let audioStem = this.props.stem ? this.props.stem.audio : '';
    let spanthml = null;
    if(additionText.length > 0 && category !== 'writing' && category !== 'speaking') {
      if(textMaterial.length > 0 ) {
        spanthml = (
          <span
            onClick={this.showAddition}
            className={style.additionText}
            >
            {this.state.showAddition ? '查看原文' : '查看译文'}
          </span>
        )
      }else if(audioMaterial) {
        spanthml = (
          <span onClick={this.showAddition} className={style.additionAudio}>{this.state.showAddition ? '查看题目' :'查看听力原文' }</span>
        )
      }
    }
    return (
      <div className={style.materialBox}>
        <div
          style={{borderTopWidth: textMaterial.length > 0 && spanthml ? '60px' : '20px'}}
          className={(textMaterial.length > 0 && category !== 'speaking' ? (category==='writing' ? style.materialWriting : style.material ) : null)}
          >
          {spanthml}
          {textMaterial.length > 0 ? (this.state.showAddition ? this.additionToHTML(additionText) : this.stemToHTML(textMaterial)) : null}
          {pictureMaterial ? <img src={`${config.cdnCommon}/${pictureMaterial}`} alt="图片"/> : null}
          {audioMaterial ? <div className={style.audioContainer}><Audio src={`${config.cdnCommon}/${audioMaterial}`} ></Audio></div> : null}
        </div>
        <div ref='stem' className={ isSingleLayout && category === 'blank' ?style.stemContent : null}>
          {pictureStem ? <div className={isSingleLayout && category === 'blank' ? style.stemImgBox: null}><img src={`${config.cdnCommon}/${pictureStem}`} alt="图片"/></div>: null}
          <div>
            {textStem ? this.stemToHTML(textStem) : null}
            {audioStem ? <div className={style.stemAudio}><Audio src={`${config.cdnCommon}/${audioStem}`}></Audio></div> : null}
          </div>
        </div>
      </div>

    )
  }
}



/** WEBPACK FOOTER **
 ** ./src/components/Practice/Material/index.js
 **/